// application global colors
// normal(2.25), dark(3.0)
export const GREY_LIGHT = '#c8c8c8';
export const YELLOW = '#ffce26';
export const YELLOW_LIGHT = '#ffeaa4';
export const BLACK = '#333333';
export const WHITE = '#ffffff';

export const STRING_COLOR = '#333333';
export const STRING_LIGHT_COLOR = '#8f8f8f';
export const MAIN_BACK_GROUND = '#f5f5f5';
export const BASE_COLOR = YELLOW;
export const BASE_BORDER_COLOR = '#dddddd';
export const SHADOW_BOX = 'drop-shadow(0 0 40px rgba(0, 0, 0, 0.2))';
export const PANEL_FILTER = 'drop-shadow(0 0 10px rgba(0,0,0,0.1))';

//
// Head Style
//
export const HEAD_COLOR = '#333333';

//
// Button Style
//
export const BUTTON_COLOR = YELLOW;
export const BUTTON_HOVER_COLOR = '#ffc000';

//
// Input Style
//
export const INPUT_BACKGROUND_COLOR = '#ffffff';
export const INPUT_BORDER_COLOR = BASE_BORDER_COLOR;
export const INPUT_COLOR = '#333333';
export const INPUT_PLACEHOLDER_COLOR = '#8f8f8f';

//
// Form Style
//
export const FORM_BORDER_COLOR = BASE_BORDER_COLOR;

//
// ant design theme(light or dark)
//
export const ANTD_HEADER_THEME = 'light';
export const ANTD_SIDEFBAR_THEME = 'dark';

//
// timeline color
//
export const SELECTED_TIMELINE_COLOR = "blue";
export const SELECT_TIMELINE_COLOR = "red";
export const OTHER_TIMELINE_COLOR = GREY_LIGHT;
export const SELECTED_TIMELINE_TEXT_COLOR = WHITE;
export const SELECT_TIMELINE_TEXT_COLOR = WHITE;
export const OTHER_TIMELINE_TEXT_COLOR = WHITE;
